/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ExpansionNavigationItem = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        icon: {
    type: 'string',
    isRequired: true,
},
        label: {
    type: 'string',
    isRequired: true,
},
        mClass: {
    type: 'string',
},
        primaryNotice: {
    type: 'string',
},
        secondaryNotice: {
    type: 'string',
},
        showHideCount: {
    type: 'boolean',
    isRequired: true,
},
        enabled: {
    type: 'boolean',
    isRequired: true,
},
        subItems: {
    type: 'array',
    contains: {
        type: 'NavigationSubItem',
    },
    isRequired: true,
},
    },
};